import { Controller } from "@hotwired/stimulus"
import Swal from "sweetalert2"

export default class extends Controller {
  static values = {
    title: String,
    text: String,
    confirmButtonText: String,
    cancelButtonText: String,
    requiredText: String
  }

  async confirm(event) {
    if (this.element.dataset.sweetalertConfirmed === "true") {
      this.element.dataset.sweetalertConfirmed = "false"
      return
    }

    event.preventDefault()

    const requiredText = this.requiredTextValue || ""
    const options = {
      title: this.titleValue || "Are you sure?",
      text: this.textValue || "",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: this.confirmButtonTextValue || "Continue",
      cancelButtonText: this.cancelButtonTextValue || "Cancel",
      confirmButtonColor: "#b45309",
      cancelButtonColor: "#57534e",
      reverseButtons: true,
      focusCancel: true
    }

    if (requiredText) {
      options.input = "text"
      options.inputLabel = `Type ${requiredText} to confirm.`
      options.inputPlaceholder = requiredText
      options.inputValidator = (value) => {
        if ((value || "").trim().toLowerCase() !== requiredText.toLowerCase()) {
          return `Please type ${requiredText} to continue.`
        }

        return null
      }
    }

    const result = await Swal.fire(options)

    if (result.isConfirmed) {
      if (requiredText) {
        const confirmationInput = this.element.querySelector('input[name="delete_confirmation"]')
        if (confirmationInput) confirmationInput.value = result.value || ""
      }

      this.element.dataset.sweetalertConfirmed = "true"
      this.element.requestSubmit()
    }
  }
}
